<template>
  <div>
    <el-form :inline="true">
      <el-form-item prop="start_date">
        <el-date-picker
          style="width:200px"
          size="small"
          v-model="searchForm.start_date"
          type="date"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          :clearable="false"
        ></el-date-picker>
        <span> -</span>
      </el-form-item>
      <el-form-item prop="end_date">
        <el-date-picker
          style="width:200px"
          size="small"
          v-model="searchForm.end_date"
          type="date"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :clearable="false"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-select placeholder="客户名称" v-model="searchForm.customer_name" size="small" clearable filterable>
          <el-option v-for="(item,index) in $store.state.customerNameList" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select placeholder="产品名称" v-model="searchForm.product_name" size="small" clearable filterable>
          <el-option v-for="(item,index) in $store.state.productNameList" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select placeholder="产品规格" v-model="searchForm.product_size" size="small" clearable filterable>
          <el-option v-for="(item,index) in $store.state.productSizeList" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="small"
          type="primary"
          icon="el-icon-search"
          @click="searchForm.page = 1;getList()"
        >搜索</el-button>
      </el-form-item>
      <el-form-item style="float:right">
        <el-button size="small" icon="el-icon-download" v-show="false">另存为Excel</el-button>
      </el-form-item>
    </el-form>
    <el-row style="margin-bottom:15px">
      <CreateCarouselButton :selectList="selectList" />
    </el-row>
    <el-alert type="success" :closable="false" style="margin-bottom:15px">
      <div slot="title">
        <span style="line-height:35px">已选派工单:</span>
        <span v-if="selectList.length === 0">无</span>
        <span v-else>
          <el-tag
            @close="$refs.produceTable.toggleRowSelection(item)"
            closable
            type="success"
            style="margin-right:10px"
            v-for="(item, index) in selectList"
            :key="item.id"
          >{{` ${index+1}、${item.product_name}(${item.product_size}) `}}</el-tag>
          <el-tag
            type="primary"
            style="margin-right:10px;cursor:pointer"
            @click="$refs['produceTable'].clearSelection()"
          >清空</el-tag>
        </span>
      </div>
    </el-alert>
    <el-table ref="produceTable" :data="produceTableList" border highlight-current-row v-loading="tableLoading"
      @sort-change="sortChange" @selection-change="(selection)=>{selectList=selection}" @row-click="row=>{$refs.produceTable.toggleRowSelection(row)}" :row-key="row=>row.id">
      <el-table-column :reserve-selection="true" type="selection" align="center"></el-table-column>
      <el-table-column prop="customer_name" label="客户名称" align="center"></el-table-column>
      <el-table-column prop="product_name" label="产品名称" align="center"></el-table-column>
      <el-table-column prop="product_size" label="产品规格" align="center" sortable="custom"></el-table-column>
      <el-table-column label="生产流程" align="center">
        <template slot-scope="scope">
          <el-popover trigger="hover" placement="bottom">
          <div v-for="(item,index) in scope.row.process" :key="index" style="text-align:left">
            <div>
              <span>
              {{`${['一','二','三','四','五','六','七','八','九','十','十一','十二'][index]}、${item.description}`}}
              </span>
              <span v-if="item.hour !== null && item.hour != 0">{{`[日产:${item.hour}]`}}</span>
            </div>
            <span v-for="(req,idx) in item.require.split(/;|；/)" :key="idx">
            <span v-if="req!==''">
              <span v-if="req.indexOf('/')===-1" style="display:inline-block">
                {{['①','②','③','④','⑤','⑥','⑦','⑧','⑨','⑩','⑪','⑫'][idx]+req.replace('@','↧').replace('^','φ')}}
              </span>
              <span style="display:inline-block" v-else>
                <span style="display:inline-block;text-align:right">
                  {{['①','②','③','④','⑤','⑥','⑦','⑧','⑨','⑩','⑪','⑫'][idx]+req.split(/[+|-]/)[0]}}
                  </span>
                  <span style="position:relative;width:50px;display:inline-block">
                    <sup
                      style="position:absolute;left:0px;bottom:5px;width:40px;display:inline-block;line-height:10px;text-align:left"
                    >{{req.match(/[+|-]/)[0]+req.split(/[+|-]/)[1].split('/')[0]}}</sup>
                    <sub
                      style="position:absolute;left:2px;top:-5px;width:40px;display:inline-block;line-height:10px;text-align:left"
                    >{{req.match(/\/(.)/)[1]+req.split(/[+|-]/)[2]}}</sub>
                  </span>
              </span>
            </span>
            <span v-else></span>
            </span>
          </div>
          <el-tag slot="reference" size="medium" style="cursor:pointer">查看</el-tag>
        </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="face" label="表面处理" align="center"></el-table-column>
      <el-table-column prop="need_hour" label="总工时" align="center"></el-table-column>
      <el-table-column prop="supplier" label="供应商" align="center"></el-table-column>
      <el-table-column prop="come_count" label="来料数量" align="center"></el-table-column>
      <el-table-column prop="come_date" label="来料日期" align="center" width="103px" sortable="custom"></el-table-column>
      <el-table-column prop="create_time" label="创建时间" align="center" width="103px" sortable="custom"></el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="100px">
        <template slot-scope="scope">
          <el-link type="primary" @click="goPrint(scope.row)">打印</el-link>
          <el-divider direction="vertical"></el-divider>
          <el-popconfirm
            confirmButtonText="确认"
            cancelButtonText="取消"
            icon="el-icon-warning-outline"
            iconColor="red"
            title="确定删除吗？"
            @onConfirm="deleteProduce(scope.row.id)"
          >
            <el-link slot="reference" type="primary">删除</el-link>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      style="margin-top:15px"
      :total="produceTableTotal"
      :current-page.sync="searchForm.page"
      @current-change="(page)=>{this.searchForm.page = page;this.getList()}"
      @size-change="(size)=>{this.searchForm.pageSize = size;this.searchForm.page = 1;this.getList()}"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      layout="prev, pager, next, ->, total, sizes"
      align="center"
    ></el-pagination>
  </div>
</template>

<script>
import { getProduceList, deleteProduce } from '../api/index'
import CreateCarouselButton from '../components/CreateCarouselButton'

export default {
  components: {
    CreateCarouselButton
  },
  data () {
    return {
      tableLoading: false,
      searchForm: {
        // come_date: '',
        start_date: new Date(new Date().getTime() - 518400000).format('yyyy-MM-dd'),
        end_date: new Date().format('yyyy-MM-dd'),
        product_name: '',
        product_size: '',
        customer_name: '',
        sortType: 'id',
        order: 'desc',
        page: 1,
        pageSize: 10
      },
      selectList: [],
      produceTableTotal: null,
      produceTableList: []
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    sortChange (sortInfo) {
      this.searchForm.sortType = sortInfo.prop
      if (sortInfo.order === 'ascending') {
        this.searchForm.order = 'asc'
      } else if (sortInfo.order === 'descending') {
        this.searchForm.order = 'desc'
      } else {
        this.searchForm.sortType = 'id'
        this.searchForm.order = 'desc'
      }
      this.searchForm.page = 1
      this.getList()
    },
    deleteProduce (id) {
      deleteProduce({ id }).then(res => {
        console.log(res)
        if (res.data.status === 200) {
          this.$message.success(res.data.msg)
          this.getList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    goPrint (row) {
      let routeData = this.$router.resolve({
        path: '/producePrintPage',
        query: {
          info: JSON.stringify(row)
        }
      })
      window.open(routeData.href, '_blank')
    },
    getList () {
      this.tableLoading = true
      getProduceList(this.searchForm).then(res => {
        if (res.data.status === 200) {
          this.produceTableList = res.data.data
          this.produceTableTotal = res.data.total
          this.tableLoading = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    }
  }
}
</script>

<style>

</style>
